import { render, staticRenderFns } from "./WebCam.vue?vue&type=template&id=0c4870fd&"
import script from "./WebCam.vue?vue&type=script&lang=js&"
export * from "./WebCam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports